import "./css/About.css";
import { FaArrowDown } from "react-icons/fa";
import { useState, useEffect } from "react";

export default function About() {
  const [showArrow, setShowArrow] = useState(true);

  const scrollDown = () => {
    window.scrollBy({ top: window.innerHeight, behavior: "smooth" });
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrolledToBottom =
        window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 20;

      if (scrolledToBottom) {
        setShowArrow(false);
      } else {
        setShowArrow(true);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const founders = [
    {
      name: "Antony Varghese Pepe",
      img: "/images/founders/antony_varghese_pepe.jpg",
    },
    {
      name: "Adarsh Chandrashekar",
      img: "/images/founders/adarsh.jpg",
    },
    {
      name: "Emmanuel John",
      img: "/images/founders/emmanuel.jpg",
    },
  ];

  return (
    <div className="about-page">
      {/* Hero Section */}
      <div className="about-hero">
        <div className="about-hero-text">
          <p>The production house of</p>
          <h1>Antony Varghese Pepe</h1>
        </div>
      </div>

      {/* Slide Down Arrow */}
      {showArrow && (
        <div className="slide-down-arrow" onClick={scrollDown}>
          <FaArrowDown />
        </div>
      )}

      {/* About Section */}
      <section className="about-section">
        <h2>About Us</h2>
        <p className="about-subtitle">
          Meet the founders of <strong>AVP Production</strong>
        </p>
        <div className="founders">
          {founders.map((f, idx) => (
            <div key={idx} className="founder-card">
              <img src={f.img} alt={f.name} />
              <p className="founder-name">{f.name}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}